module.exports = __webpack_public_path__ + "static/media/trademark.ed02adff.svg";